<div class="card cardAgreement" (click)="goToAgreement()" style="align-items: center;padding: 8px;place-content: center;">
     <!-- <img class="benefitIMG" [src]="agreement.cus_url_image_web |safeUrl"> -->
     <img [src]="URL_DOCS+agreement.agre_path |safeUrl" class=" benefitIMG img-fluid" alt="...">
</div>